<div class="info-card">
  <div class="info-card-header">
    @if (icon) {
    <lucide-icon [name]="icon" class="-lucide-icon"></lucide-icon>
    }
    <h3>{{ title }}</h3>
  </div>
  <div class="info-card-body">
    <ng-content></ng-content>
  </div>
</div>
